module.exports = __webpack_public_path__ + "static/media/security-x.9cae9b6b.svg";